import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map, Observable} from 'rxjs';
import {ProductoAdjunto} from '../_models/producto-adjunto';

@Injectable({
  providedIn: 'root'
})
export class ProductoAdjuntoService {
  private route: string = `${AppSettings.rutServiciosAPL}/api/productosAdjuntos`;

  constructor(
    private httpClient: HttpClient,
    private authService: AutenticacionService
  ) {}

  getAll(): Observable<ProductoAdjunto[]> {
    return this.httpClient.get<ProductoAdjunto[]>(this.route);
  }

  getAllEnabled(): Observable<ProductoAdjunto[]> {
    return this.httpClient.get<ProductoAdjunto[]>(`${this.route}/enabled}`);
  }

  getById(id: string): Observable<ProductoAdjunto[]> {
    return this.httpClient.get<ProductoAdjunto[]>(`${this.route}/${id}`);
  }

  getByIdProductoEnabled(id: string): Observable<ProductoAdjunto[]> {
    return this.httpClient.get<ProductoAdjunto[]>(`${this.route}/producto/${id}/dataTable`).pipe(
      map(records => records.map(record => ({
        ...record,
        tiposVinculacionesNames: record.tiposVinculaciones?.map(e => e.tipoVinculacion).join(', ') ?? '',
        tiposPersonasNames: record.tiposPersonas?.map(e => e.tipoPersona).join(', ') ?? '',
        tiposOcupacionesNames: record.tiposOcupaciones?.map(e => e.tipoOcupacion).join(', ') ?? '',
      })))
    );
  }

  save(record: ProductoAdjunto): Observable<ProductoAdjunto> {
    record.productosAdjuntos.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoAdjunto>(`${this.route}/transaccion`, record);
  }

  createBulk(records: ProductoAdjunto[]): Observable<ProductoAdjunto[]> {
    records.forEach((e: ProductoAdjunto) => e.productosAdjuntos.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoAdjunto[]>(`${this.route}/bulk`, records);
  }

  updateBulk(records: ProductoAdjunto[]): Observable<ProductoAdjunto[]> {
    records.forEach((e: ProductoAdjunto) => e.productosAdjuntos.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.put<ProductoAdjunto[]>(`${this.route}/bulk`, records);
  }
}
